/**
 * Pantalla de carga global: isotipo MANAXER estático (inline SVG, sin
 * dependencia de PNG) + barra de progreso naranja debajo, pegada al logo,
 * con el mismo ancho visual. Se lee como una unidad.
 */
export function LoadingScreen({ message }: { message?: string } = {}) {
  return (
    <div className="grid min-h-screen place-items-center px-6">
      <div className="flex flex-col items-center">
        <BrandIsotipo className="h-20 w-auto" />
        <div className="brand-progress mt-1" aria-hidden>
          <div className="brand-progress-fill" />
        </div>
        {message && (
          <p className="mt-5 text-xs font-semibold uppercase tracking-[0.18em] text-neutral-muted">
            {message}
          </p>
        )}
      </div>
    </div>
  );
}

/** Isotipo MANAXER como SVG inline — 3 barras + polilínea "M" + nodos. */
function BrandIsotipo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 160 140" fill="none" className={className} aria-hidden>
      <defs>
        <linearGradient id="ls-bar1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#A9D6E9" />
          <stop offset="1" stopColor="#8FC5DA" />
        </linearGradient>
        <linearGradient id="ls-bar2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#0F6F95" />
          <stop offset="1" stopColor="#0B5C7E" />
        </linearGradient>
        <linearGradient id="ls-bar3" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#FF8A1A" />
          <stop offset="1" stopColor="#E96F00" />
        </linearGradient>
      </defs>
      {/* Barras */}
      <rect x="14" y="82" width="26" height="48" rx="10" fill="url(#ls-bar1)" />
      <rect x="58" y="52" width="26" height="78" rx="10" fill="url(#ls-bar2)" />
      <rect x="102" y="34" width="26" height="96" rx="10" fill="url(#ls-bar3)" />
      {/* Polilínea "M" */}
      <polyline
        points="22,72 45,28 70,44 95,25 118,10"
        stroke="#A9D6E9"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Nodos */}
      <g>
        <circle cx="22" cy="72" r="10" fill="#A9D6E9" />
        <circle cx="22" cy="72" r="4" fill="#FF8A1A" />
      </g>
      <g>
        <circle cx="70" cy="44" r="10" fill="#A9D6E9" />
        <circle cx="70" cy="44" r="4" fill="#FF8A1A" />
      </g>
      <g>
        <circle cx="118" cy="10" r="11" fill="#0F6F95" />
        <circle cx="118" cy="10" r="5" fill="#FFFFFF" />
      </g>
    </svg>
  );
}
